/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RaffleTokenRegistry } from "../RaffleTokenRegistry";

export class RaffleTokenRegistry__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<RaffleTokenRegistry> {
    return super.deploy(overrides || {}) as Promise<RaffleTokenRegistry>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): RaffleTokenRegistry {
    return super.attach(address) as RaffleTokenRegistry;
  }
  connect(signer: Signer): RaffleTokenRegistry__factory {
    return super.connect(signer) as RaffleTokenRegistry__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RaffleTokenRegistry {
    return new Contract(address, _abi, signerOrProvider) as RaffleTokenRegistry;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
    ],
    name: "TokenAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TokenRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
    ],
    name: "TokenUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "enabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minTokenAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "remove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
    ],
    name: "updateMinAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
